(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["book-me"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function openDialog(dialog) {
      if (!dialog) return

      if (typeof dialog.showModal === 'function') {
        dialog.showModal()
      } else {
        dialog.setAttribute('open', '')
      }
    }

    function closeDialog(dialog) {
      if (!dialog) return

      if (typeof dialog.close === 'function') {
        dialog.close()
      } else {
        dialog.removeAttribute('open')
      }
    }

    function showSuccessScreen(dialog) {
      if (!dialog) return

      var successScreen = dialog.querySelector('[data-book-me-success-screen]')
      var formFields = dialog.querySelector('[data-book-me-form-fields]')
      var dialogTitle = dialog.querySelector('[data-book-me-dialog-title]')

      if (successScreen) successScreen.hidden = false
      if (formFields) formFields.hidden = true
      if (dialogTitle) dialogTitle.hidden = true
    }

    function showFormScreen(dialog) {
      if (!dialog) return

      var successScreen = dialog.querySelector('[data-book-me-success-screen]')
      var formFields = dialog.querySelector('[data-book-me-form-fields]')
      var dialogTitle = dialog.querySelector('[data-book-me-dialog-title]')

      if (successScreen) successScreen.hidden = true
      if (formFields) formFields.hidden = false
      if (dialogTitle) dialogTitle.hidden = false
    }

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-book-me-form]')

      if (!form) return

      var dialog = form.closest('[data-book-me-dialog]')

      if (dialog && form.checkValidity()) {
        try {
          sessionStorage.setItem('bookMeSubmittedDialogId', dialog.id)
        } catch (error) {
          // Storage can be unavailable in some browser privacy modes.
        }
      }
    })

    document.addEventListener('click', function (event) {
      var openButton = event.target.closest('[data-book-me-dialog-open]')

      if (openButton) {
        var dialog = document.getElementById(openButton.getAttribute('data-book-me-dialog-open'))
        showFormScreen(dialog)
        openDialog(dialog)
        return
      }

      var closeButton = event.target.closest('[data-book-me-dialog-close]')

      if (closeButton) {
        closeDialog(closeButton.closest('[data-book-me-dialog]'))
        return
      }

      if (event.target.matches('[data-book-me-dialog]')) {
        closeDialog(event.target)
      }
    })

    function openSubmittedDialogs() {
      var submittedDialogId = null

      try {
        submittedDialogId = sessionStorage.getItem('bookMeSubmittedDialogId')
      } catch (error) {
        submittedDialogId = null
      }

      document.querySelectorAll('[data-book-me-dialog]').forEach(function (dialog) {
        var hasServerSuccess = dialog.querySelector('[data-book-me-success-screen][data-book-me-dialog-auto-open]')
        var hasServerError = dialog.querySelector('[data-book-me-dialog-error]')

        if (hasServerSuccess) {
          showSuccessScreen(dialog)
          openDialog(dialog)

          if (submittedDialogId === dialog.id) {
            try {
              sessionStorage.removeItem('bookMeSubmittedDialogId')
            } catch (error) {
              // Storage can be unavailable in some browser privacy modes.
            }
          }

          return
        }

        if (!hasServerError && submittedDialogId === dialog.id) {
          showSuccessScreen(dialog)
          openDialog(dialog)

          try {
            sessionStorage.removeItem('bookMeSubmittedDialogId')
          } catch (error) {
            // Storage can be unavailable in some browser privacy modes.
          }

          return
        }

        if (hasServerError || dialog.querySelector('[data-book-me-dialog-auto-open]')) {
          openDialog(dialog)
        }
      })
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', openSubmittedDialogs)
    } else {
      openSubmittedDialogs()
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.querySelectorAll('[data-cart-section]').forEach(function(section) {
    var moneyCode = section.getAttribute('data-money-code') || 'USD';
    var subtotal = section.querySelector('[data-cart-subtotal]');
    var debounceDelay = 400;

    function formatMoney(cents) {
      var amount = Number(cents || 0) / 100;
      try {
        var formatted = new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: moneyCode
        }).format(amount);
        return formatted.replace(/\.00$/, '');
      } catch (error) {
        return '$' + amount.toFixed(2).replace(/\.00$/, '');
      }
    }

    function updateHeaderCount(count) {
      var cartLink = document.querySelector('.site-header__cart span');
      if (!cartLink) return;
      cartLink.textContent = 'Cart (' + count + ')';
    }

    function changeCartQuantity(item, quantity) {
      var line = parseInt(item.getAttribute('data-cart-line'), 10);
      if (!line) return;

      item.cartUpdateRequest = (item.cartUpdateRequest || 0) + 1;
      var requestId = item.cartUpdateRequest;

      item.setAttribute('aria-busy', 'true');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function(response) {
          if (!response.ok) throw new Error('Cart update failed');
          return response.json();
        })
        .then(function(cart) {
          if (requestId !== item.cartUpdateRequest) return;

          if (cart.item_count === 0 || quantity === 0) {
            window.location.reload();
            return;
          }

          var updatedItem = cart.items[line - 1];
          var itemTotal = item.querySelector('[data-cart-item-total]');

          if (updatedItem && itemTotal) itemTotal.textContent = formatMoney(updatedItem.final_line_price);
          if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
          updateHeaderCount(cart.item_count);
        })
        .catch(function() {
          window.location.reload();
        })
        .finally(function() {
          if (requestId === item.cartUpdateRequest) item.removeAttribute('aria-busy');
        });
    }

    section.querySelectorAll('[data-cart-quantity]').forEach(function(control) {
      var input = control.querySelector('[data-cart-quantity-input]');
      var minus = control.querySelector('[data-cart-quantity-minus]');
      var plus = control.querySelector('[data-cart-quantity-plus]');
      var item = control.closest('[data-cart-item]');
      var debounceTimer;

      if (!input || !item) return;

      function minQuantity() {
        var min = parseInt(input.getAttribute('min') || '0', 10);
        if (isNaN(min)) min = 0;
        return min;
      }

      function quantity() {
        var min = minQuantity();
        var value = parseInt(input.value, 10);
        if (isNaN(value)) value = min;
        if (value < min) value = min;
        input.value = value;
        return value;
      }

      function renderState() {
        if (minus) minus.disabled = quantity() <= minQuantity();
      }

      function scheduleCartUpdate() {
        var value = quantity();
        renderState();
        item.setAttribute('aria-busy', 'true');

        window.clearTimeout(debounceTimer);
        debounceTimer = window.setTimeout(function() {
          changeCartQuantity(item, value);
        }, debounceDelay);
      }

      if (minus) {
        minus.addEventListener('click', function() {
          input.value = quantity() - 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      if (plus) {
        plus.addEventListener('click', function() {
          input.value = quantity() + 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      input.addEventListener('input', renderState);
      input.addEventListener('change', scheduleCartUpdate);
      renderState();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('[data-product-section]').forEach(function(section) {
    var mainMedia = section.querySelector('[data-main-media] img');
    var thumbs = section.querySelectorAll('[data-gallery-thumb]');
    var variantSelect = section.querySelector('[data-variant-select]');
    var variantInput = section.querySelector('input[name="id"]');
    var quantityInput = section.querySelector('[data-quantity-input]');
    var minus = section.querySelector('[data-quantity-minus]');
    var plus = section.querySelector('[data-quantity-plus]');
    var addButton = section.querySelector('[data-add-button]');
    var addLabel = section.querySelector('[data-add-label]');
    var addLabelText = section.querySelector('[data-add-label-text]');
    var addPrice = section.querySelector('[data-add-price]');
    var productPrice = section.querySelector('[data-product-price]');
    var inventoryNote = section.querySelector('[data-inventory-note]');
    var moneyCode = section.getAttribute('data-money-code') || 'USD';
    var inventoryItemLeftTemplate = section.getAttribute('data-inventory-item-left-template') || 'Only __COUNT__ left';
    var inventoryItemsLeftTemplate = section.getAttribute('data-inventory-items-left-template') || 'Only __COUNT__ left';

    function formatMoney(cents) {
      var amount = Number(cents || 0) / 100;
      try {
        var formatted = new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: moneyCode
        }).format(amount);
        return formatted.replace(/\.00$/, '');
      } catch (error) {
        return '$' + amount.toFixed(2).replace(/\.00$/, '');
      }
    }

    function selectedOption() {
      if (variantSelect) return variantSelect.options[variantSelect.selectedIndex];
      return variantInput;
    }

    function inventoryText(count) {
      var template = count === 1 ? inventoryItemLeftTemplate : inventoryItemsLeftTemplate;
      return template.replace('__COUNT__', count);
    }

    function renderInventory(option) {
      if (!inventoryNote) return;

      var inventoryManagement = option ? option.getAttribute('data-inventory-management') : '';
      var inventoryPolicy = option ? option.getAttribute('data-inventory-policy') : '';
      var inventoryQuantity = option ? parseInt(option.getAttribute('data-inventory-quantity'), 10) : 0;
      var shouldShow = inventoryManagement === 'shopify' && inventoryPolicy === 'deny' && inventoryQuantity > 0;
      var text = shouldShow ? inventoryText(inventoryQuantity) : '';

      inventoryNote.textContent = text;
      inventoryNote.classList.toggle('product-detail__inventory-note--hidden', !shouldShow);
    }

    function quantity() {
      var value = parseInt(quantityInput.value, 10);
      if (isNaN(value) || value < 1) value = 1;
      if (value > 12) value = 12;
      quantityInput.value = value;
      return value;
    }

    function renderPurchaseState() {
      if (!quantityInput || !addButton) return;

      var option = selectedOption();
      var price = option ? parseInt(option.getAttribute('data-price'), 10) : 0;
      var formattedPrice = option ? option.getAttribute('data-price-formatted') : '';
      var available = option ? option.getAttribute('data-available') === 'true' : false;
      var qty = quantity();

      if (minus) minus.disabled = qty <= 1;
      if (plus) plus.disabled = qty >= 12;

      if (productPrice && formattedPrice) productPrice.textContent = formattedPrice;
      renderInventory(option);

      if (!available) {
        addButton.disabled = true;
        if (addLabel) addLabel.textContent = addButton.getAttribute('data-sold-out-text');
        return;
      }

      addButton.disabled = false;
      if (addLabelText) addLabelText.textContent = addButton.getAttribute('data-add-text');
      if (addPrice) addPrice.textContent = formatMoney(price * qty);
    }

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        if (!mainMedia) return;
        thumbs.forEach(function(item) { item.setAttribute('aria-selected', 'false'); });
        thumb.setAttribute('aria-selected', 'true');
        mainMedia.removeAttribute('srcset');
        mainMedia.src = thumb.getAttribute('data-main-src');
        mainMedia.alt = thumb.getAttribute('data-main-alt') || '';
      });
    });

    if (minus) {
      minus.addEventListener('click', function() {
        quantityInput.value = quantity() - 1;
        renderPurchaseState();
      });
    }

    if (plus) {
      plus.addEventListener('click', function() {
        quantityInput.value = quantity() + 1;
        renderPurchaseState();
      });
    }

    if (quantityInput) quantityInput.addEventListener('input', renderPurchaseState);
    if (variantSelect) variantSelect.addEventListener('change', renderPurchaseState);

    renderPurchaseState();
  });

  } catch(e) { console.error(e); }
})();
})();
